import React from 'react'

import './modal_dates_proposition.css'
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import {makeStyles} from '@mui/styles';
import Form from 'react-bootstrap/Form'




const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    },
    input: {
      display: 'none',
    },
  }));



function Modal_dates_proposition({view_auditor_commission_suggestion,setView_auditor_commission_suggestion,departement}){

    return (
        <Dialog className="dates_proposition_dialog" fullWidth={true} maxWidth="md" open={view_auditor_commission_suggestion!=null?true:false} onClose={()=>setView_auditor_commission_suggestion(null)} aria-labelledby="form-dialog-title" >            
            <DialogTitle id="form-dialog-title">Intervalle de disponibilité</DialogTitle>
            <DialogContent>
                <div className="plus_details_dialog_container">
                        <TextField
                            readOnly
                            variant='standard'
                            type="text"
                            label="Début" value={
                                departement==="jurdique"
                                    ?(new Date(view_auditor_commission_suggestion.legal_available_startDate)).toLocaleString()
                                    :departement==="finance"
                                        ?(new Date(view_auditor_commission_suggestion.finance_available_startDate)).toLocaleString()
                                        :(new Date(view_auditor_commission_suggestion.technical_available_startDate)).toLocaleString()
                                
                                }  className="header_form" 
                            InputProps={{ startAdornment: ( <InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment> )}}
                       />
                        <TextField
                            readOnly
                            variant='standard'
                            type="text"
                            className="header_form" label="Fin" 
                            value={
                                departement==="jurdique"
                                    ?(new Date(view_auditor_commission_suggestion.legal_available_endDate)).toLocaleString()
                                    :departement==="finance"
                                        ?(new Date(view_auditor_commission_suggestion.finance_available_endDate)).toLocaleString()
                                        :(new Date(view_auditor_commission_suggestion.technical_available_endDate)).toLocaleString()
                                
                                } 
                            InputProps={{ startAdornment: ( <InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment> )}}
                       />
                        
                </div>
                <div style={{margin:"20px 0px 10px 0px"}}>
                    <InputLabel htmlFor='reason'>Motif</InputLabel>
                    <Form.Group name="reason" style={{width: '100%',height: '100%',position: 'relative',padding:"0px"}} >
                        <Form.Control as="textarea" placeholder='Motif...' minRows={9} 
                            value={
                                departement==="jurdique"
                                    ?view_auditor_commission_suggestion.legal_refuse_raison
                                    :departement==="finance"
                                        ?view_auditor_commission_suggestion.financial_refuse_raison
                                        :view_auditor_commission_suggestion.technical_refuse_raison
                                
                                } />
                    </Form.Group>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default Modal_dates_proposition
